import { Delegate } from "dom-delegate";
import { nodesToArray, addClass, removeClass } from "@pod-point/dom-ops";
import wavestation from "wavestation";

let instances = [];

const IS_ACTIVE = "is-active";
const ERROR_MESSAGE = "Sorry, something has gone wrong!";

class AjaxEntry {
    /**
     * New Ajax entry element.
     *
     * @param {HTMLElement} element
     * @return {void}
     */
    constructor(element) {
        this.triggers = nodesToArray(element.querySelectorAll("[data-ajax-trigger]")) || [];
        if (element.hasAttribute("data-ajax-trigger")) this.triggers.push(element);
        this.contentContainer = document.querySelector("[data-ajax-content]");

        this.fetch = null;
        var that = this;
        import("whatwg-fetch").then(({ default: fetch }) => {
            that.fetch = fetch;
        });

        this.applyDefaultState();
        this.bindEvents();
    }

    /**
     * Load ajax entry if there is an active trigger to start with.
     *
     * @return {void}
     */
    applyDefaultState() {
        this.triggers.forEach((trigger) => {
            if (trigger.classList.contains(IS_ACTIVE)) {
                const url = trigger.getAttribute("data-ajax-entry");
                this.ajaxContent(url);
            }
        });
    }

    /**
     * Binds the event listeners from the elements.
     *
     * @return {void}
     */
    bindEvents() {
        this.triggerListeners = [];

        this.triggers.forEach((trigger) => {
            const triggerListener = new Delegate(trigger);
            this.triggerListeners.push(triggerListener);

            triggerListener.on("click", (event, clickedElement) => {
                this.handleTrigger(clickedElement);
            });
        });
    }

    /**
     * Handles the trigger.
     *
     * @param {HTMLElement} clickedElement
     * @return {void}
     */
    handleTrigger(clickedElement) {
        this.applyActiveClass(clickedElement);
        const url = clickedElement.getAttribute("data-ajax-entry");

        if (this.contentContainer.getAttribute("data-content-url") !== url) {
            this.ajaxContent(url);
        }
    }

    /**
     * Remove all other active classes and apply correct one.
     *
     * @param {HTMLElement} clickedElement
     * @return {void}
     */
    applyActiveClass(clickedElement) {
        this.triggers.forEach((trigger) => {
            removeClass(trigger, IS_ACTIVE);
        });
        addClass(clickedElement, IS_ACTIVE);
    }

    /**
     * Load content from selected Craft entry.
     *
     * @param {String} url
     * @return {void}
     */
    ajaxContent(url) {
        const contentContainer = this.contentContainer;

        const request = new Request(url, {
            method: "get",
            headers: new Headers({
                "X-Requested-With": "XMLHttpRequest",
            }),
        });

        this.fetch(request)
            .then((response) => response.json())
            .then((data) => {
                contentContainer.innerHTML = data.content;
                contentContainer.setAttribute("data-content-url", url);
                wavestation.broadcast("ajax-entry", contentContainer);
            })
            .catch(() => {
                this.handleError();
            });
    }

    /**
     * Handle error from Ajax request.
     *
     * @return {void}
     */
    handleError() {
        const errorHtml = `<p class="width-100 text-centre">${ERROR_MESSAGE}</p>`;
        this.contentContainer.innerHTML = errorHtml;
    }

    /**
     * Unbinds the event listeners from the elements.
     *
     * @return {void}
     */
    unbindEvents() {
        this.triggerListeners.destroy();
    }
}

export default {
    init: (element) => {
        instances.push(new AjaxEntry(element));
    },

    destroy: () => {
        instances.forEach((instance) => instance.unbindEvents());
        instances = [];
    },
};
